"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonToMap = exports.mapToJson = exports.getKeyNameStore = exports.isServer = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var isServer = !process.browser; // getCounterStore => counterStore

exports.isServer = isServer;

var getKeyNameStore = function getKeyNameStore(fnName) {
  return fnName.replace(/^get(.)/, function (match, p1) {
    return p1.toLowerCase();
  });
};

exports.getKeyNameStore = getKeyNameStore;

var mapToJson = function mapToJson(map) {
  try {
    return JSON.stringify(_toConsumableArray(map));
  } catch (e) {
    return map;
  }
};

exports.mapToJson = mapToJson;

var jsonToMap = function jsonToMap(jsonStr) {
  if (!jsonStr) {
    return jsonStr;
  }

  try {
    return new Map(JSON.parse(jsonStr));
  } catch (e) {
    return jsonStr;
  }
};

exports.jsonToMap = jsonToMap;
//# sourceMappingURL=utils.js.map